export const YANDEX_MAP_CUSTOM_STYLE = [
  {
    tags: {
      any: ['outdoor', 'park', 'cemetery', 'medical'],
    },
    elements: 'label',
    stylers: {
      visibility: 'off',
    },
  },
  {
    tags: {
      any: 'poi',
      none: ['outdoor', 'park', 'cemetery', 'medical'],
    },
    stylers: {
      visibility: 'off',
    },
  },
  {
    tags: {
      any: 'road',
    },
    types: 'point',
    stylers: {
      visibility: 'off',
    },
  },
  {
    tags: {
      any: ['food_and_drink', 'shopping', 'commercial_services'],
    },
    stylers: {
      visibility: 'off',
    },
  },
  {
    tags: {
      any: ['traffic_light'],
    },
    stylers: {
      visibility: 'off',
    },
  },
  {
    tags: {
      any: ['entrance'],
    },
    stylers: {
      visibility: 'off',
    },
  },
  {
    tags: {
      any: ['road'],
      none: ['road_1', 'road_2', 'road_3', 'road_4', 'road_5', 'road_6', 'road_7'],
    },
    elements: 'label.icon',
    stylers: {
      visibility: 'off',
    },
  },
] as const;